<div v-if="is_verification_view" class="mt-2">

  <!-- PAGE HEADER -->
  <div class="mb-3">
    <p class="text-muted mb-0 text-xs">
      Manage your BEE verification documentation by element
    </p>
  </div>

  <!-- VERIFICATION ITEMS -->
  <div class="d-flex flex-column gap-3">

    <div
      v-for="item in filtered_items"
      :key="item.id"
      class="card border-primary shadow-sm rounded-4"
    >
      <div class="card-body p-3">

        <!-- ROW -->
        <div class="row align-items-center g-3">

          <!-- LEFT: ICON + CONTENT -->
          <div class="col-12 col-md-7 d-flex align-items-start gap-3">

            <!-- ICON -->
            <div
              class="rounded-3 d-flex align-items-center justify-content-center p-3"
              :class="item.icon_bg_class || 'bg-success-subtle text-success'"
            >
              <i :class="['bi', item.icon || 'bi-folder']"></i>
            </div>

            <!-- CONTENT -->
            <div class="flex-grow-1">

              <div class="d-flex align-items-center gap-2 mb-1">
                <div class="fw-semibold text-xs">
                  {{ item.title }}
                </div>

                <span
                  v-if="item.status"
                  class="badge rounded-pill text-xs"
                  :class="item.status_class || 'bg-warning-subtle text-white'"
                >
                  {{ item.status }}
                </span>
              </div>

              <p class="text-muted mb-1 text-xs">
                {{ item.subtitle }}
              </p>

              <div class="d-flex flex-wrap gap-3 text-muted text-xs">
                <span v-if="item.type">
                  <i class="bi bi-tag me-1"></i>{{ item.type }}
                </span>
                <span v-if="item.last_updated">
                  <i class="bi bi-calendar me-1"></i>{{ item.last_updated }}
                </span>
              </div>

            </div>
          </div>

          <!-- RIGHT: PROGRESS + TOGGLE -->
          <div class="col-12 col-md-5 d-flex justify-content-md-end align-items-center gap-3">

            <div v-if="item.progress !== undefined" class="text-end">
              <div class="fw-semibold text-xs">
                {{ item.progress }}%
              </div>
              <div class="text-muted text-xs">
                Complete
              </div>
            </div>

            <button
              class="btn btn-outline-secondary btn-sm rounded-3 text-xs"
              @click="toggle_expand(item.id)"
            >
              <i
                :class="[
                  'bi',
                  expanded_items_set[item.id]
                    ? 'bi-chevron-up'
                    : 'bi-chevron-down'
                ]"
              ></i>
            </button>

          </div>
        </div>

        <!-- EXPANDED -->
        <div
          v-if="expanded_items_set[item.id]"
          class="mt-3 pt-3 border-top"
        >
          <p class="text-muted mb-2 text-xs">
            {{ item.description }}
          </p>

          <div class="d-flex gap-2">
            <button class="btn btn-primary btn-sm rounded-3 text-xs">
              <i class="bi bi-pencil me-1"></i>Edit
            </button>

            <button class="btn btn-outline-secondary btn-sm rounded-3 text-xs">
              <i class="bi bi-download me-1"></i>Download
            </button>
          </div>
        </div>

      </div>
    </div>

  </div>
</div>
